import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mee › Hồ sơ giấy tờ (Docs.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'dc.contract': 'Hợp đồng',
  'dc.expiring': 'Giấy tờ có hạn',
  'dc.cancel': 'Huỷ',
  'dc.kind': 'Loại giấy tờ',
  'dc.issued': 'Ngày cấp',
  'dc.expires': 'Hết hạn',
  'dc.drop': 'Kéo bản scan PDF / ảnh vào đây',
  'dc.reqUpdate': 'Yêu cầu cập nhật',
  'dc.sendHr': 'Gửi HR xác nhận',
  'dc.addPaper': 'Thêm giấy tờ',
  'dc.locConsent': 'Đồng ý ghi vị trí',
  'dc.locOn': 'Cho phép ghi vị trí khi chấm công',
  'dc.locOff': 'Chưa đồng ý ghi vị trí',
  'dc.locHint': 'Chưa đồng ý thì app chỉ ghi ảnh, không ghi GPS',
  'dc.locAgreed': 'Đã đồng ý',
  'dc.locNone': 'Chưa đồng ý',
  'dc.locAgree': 'Đồng ý',
  'dc.locRevoke': 'Thu hồi',
  'dc.locSigned': 'Đã đồng ý ghi vị trí · lưu {f}',
  'dc.locRevoked': 'Đã thu hồi đồng ý ghi vị trí',
});
addMessages('en', {
  'dc.contract': 'Contract',
  'dc.expiring': 'Expiring documents',
  'dc.cancel': 'Cancel',
  'dc.kind': 'Document type',
  'dc.issued': 'Issue date',
  'dc.expires': 'Expires',
  'dc.drop': 'Drag a scanned PDF / image here',
  'dc.reqUpdate': 'Request update',
  'dc.sendHr': 'Send to HR to confirm',
  'dc.addPaper': 'Add document',
  'dc.locConsent': 'Location consent',
  'dc.locOn': 'Location recorded at check-in',
  'dc.locOff': 'Location consent not given',
  'dc.locHint': 'Without consent the app records the photo only, no GPS',
  'dc.locAgreed': 'Agreed',
  'dc.locNone': 'Not agreed',
  'dc.locAgree': 'Agree',
  'dc.locRevoke': 'Revoke',
  'dc.locSigned': 'Location consent given · saved {f}',
  'dc.locRevoked': 'Location consent revoked',
});
